import { Component } from "@/types/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "brandTagline"

export const presets = {}

export interface Props extends Component {}

export function BrandTagline({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <div className={cx(`text-text-secondary leading-relaxed`, className)} data-test={testId}>
      Master the fundamentals of cybersecurity
    </div>
  )
}
